import { defineStore } from 'pinia';

export const useAppStore = defineStore('app', {
  state: () => ({
    containerId: undefined,
    isWidget: undefined
  }),
  actions: {
    setContainerId(containerId) {
      this.containerId = containerId;
    }
  }
});
